var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAboutIt02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 34,
    viewBox: "0 0 42 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.71189 2.64604V4.7614H2.385H0.0581055V19.1458V33.5303H18.6733H37.2884V31.4149V29.2996H39.6153H41.9422V14.9151V0.530685H23.327H4.71189V2.64604ZM40.2499 14.9151V27.6073H38.7692H37.2884V16.1843V4.7614H21.8463H6.40418V3.49219V2.22297H23.327H40.2499V14.9151ZM35.5961 19.1458V31.838H18.6733H1.75039V19.1458V6.45369H18.6733H35.5961V19.1458Z",
    fill: "#FF5B37"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.11174 13.4344C7.92713 13.9421 6.82715 15.5498 6.82715 16.819C6.82715 17.1152 7.33483 17.9613 7.92713 18.6805C9.45019 20.4997 11.3963 20.4997 12.9194 18.6805C14.1886 17.1998 14.2732 16.6075 13.3848 14.9575C12.5809 13.3498 10.7617 12.7152 9.11174 13.4344ZM12.4117 15.5498C13.0463 16.9036 11.904 18.7228 10.4233 18.7228C8.51943 18.7228 7.58868 15.8882 9.11174 14.8306C10.1694 14.1113 11.904 14.4921 12.4117 15.5498Z",
    fill: "#FF5B37"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3652 17.4532C20.3652 18.257 20.6614 18.2993 26.2882 18.2993C31.9151 18.2993 32.2112 18.257 32.2112 17.4532C32.2112 16.6493 31.9151 16.607 26.2882 16.607C20.6614 16.607 20.3652 16.6493 20.3652 17.4532Z",
    fill: "#FF5B37"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.05422 21.0495C6.70039 21.7687 5.76963 23.1649 5.38887 24.9841C5.09272 26.1687 5.17733 26.3379 5.93886 26.3379C6.61577 26.3379 6.82731 26.084 6.82731 25.1533C6.86962 22.6572 9.49266 21.1764 12.0311 22.2764C13.258 22.7841 13.6388 23.2072 14.0195 24.6033C14.2734 25.6187 14.7387 26.3379 15.0772 26.3379C16.6003 26.3379 15.0772 22.4879 13.0888 21.261C11.4811 20.288 9.61958 20.2034 8.05422 21.0495Z",
    fill: "#FF5B37"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3652 22.5303C20.3652 23.3342 20.6614 23.3765 26.2882 23.3765C31.9151 23.3765 32.2112 23.3342 32.2112 22.5303C32.2112 21.7265 31.9151 21.6842 26.2882 21.6842C20.6614 21.6842 20.3652 21.7265 20.3652 22.5303Z",
    fill: "#FF5B37"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutIt02);
export default __webpack_public_path__ + "static/media/about-it-02.67cefb0cfc68cc1f17d2aa9c7113bcb7.svg";
export { ForwardRef as ReactComponent };